import request from "../config/axios-config";

export function getAllContracts(year, query) {
  let url = "/contracts/" + year;
  if (query && query.trim().length > 0) {
    url += "?q=" + encodeURIComponent(query.trim());
  }
  return request({
    method: "get",
    url: url
  });
}
